
import { connect } from 'react-redux';

import TravFooter from '../../new-home/footer/component';

function ApplicationFooterComponent() {
  return <TravFooter />;
}

export const ApplicationFooter = connect()(ApplicationFooterComponent);
